import * as CollectionOutgoingInvoiceActions from './outgoing-invoice.actions';

export { CollectionOutgoingInvoiceActions };
